import {h, Component} from "preact";
import animate from "./animate";

export default class AutomatedSlider extends Component {
	currentSlideIndex = 0;

	componentWillMount() {
		this.scrollInterval = setInterval(() => {
			this.scrollToNext();
		}, 5e3);
	}

	componentWillUnmount() {
		clearInterval(this.scrollInterval);
	}

	scrollToNext() {
		if (!this.scrollableDiv)
			return;
		if (this.hasMouseOver)
			return;

		const parentRect = this.scrollableDiv.getBoundingClientRect();
		const slidesWrapper = this.scrollableDiv.childNodes[0];
		const slidesList = slidesWrapper.childNodes;
		
		this.currentSlideIndex = (1 + this.currentSlideIndex) % slidesList.length;
		const nextSlideIdx = this.currentSlideIndex;
		
		const nextSlide = slidesList[nextSlideIdx];
		const nextSlideRect = nextSlide.getBoundingClientRect();
		
		const horizontalDistance = nextSlideRect.x - parentRect.x;
		const startScroll = this.scrollableDiv.scrollLeft;

		animate(t => this.scrollableDiv.scrollTo(startScroll + (horizontalDistance * t), 0), 0.4e3);
	}

    render(props) {
        return <div class={"overflow-x-auto fn-scroll-container "+props.class} ref={el => this.scrollableDiv = el} onMouseEnter={() => this.hasMouseOver = true} onMouseLeave={() => this.hasMouseOver = false}>
			{this.props.children}
		</div>;
    }
}
